module.exports = __webpack_public_path__ + "img/icon-line-lg.4011232e.png";